import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GestionProveedoresRoutingModule } from './gestion-proveedores-routing.module';
import { GestionProveedoresComponent } from './gestion-proveedores.component';
import { AnulacionOsComponent } from './anulacion-os/anulacion-os.component';
import { NotasCreditoProveedoresComponent } from './notas-credito-proveedores/notas-credito-proveedores.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { FormatNumberPipe } from '../pipe/monto.pipe';
import { DialogFormComponent } from './dialog-form/dialog-form.component';
import { UploadFilesComponent } from './upload-files/upload-files.component';


@NgModule({
  declarations: [
    GestionProveedoresComponent,
    AnulacionOsComponent,
    NotasCreditoProveedoresComponent,
    DialogFormComponent,
    UploadFilesComponent
  ],
  imports: [
    CommonModule,
    GestionProveedoresRoutingModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FormatNumberPipe
  ]
})
export class GestionProveedoresModule { }
